module.exports = __webpack_public_path__ + "video/400_KMSAT15_2022_Cybercrime_Strategies-Ransomware.55b01920.vtt";